import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import ResponseError from '../../../shared/responses/ResponseError';

class SucursalList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      selectedRowKeys: [],
    };
  }

  columns = (handleEdit, handleOnDelete) => {
    return [
      {
        align: 'center',
        key: '__',
        title: '',
        dataIndex: '__',
        render: (item) => {
          return (
            <>
              <Button
                variant="danger"
                size="sm"
                onClick={handleOnDelete.bind(null, item)}
              >
                <FontAwesomeIcon icon={['fas', 'trash']} />
              </Button>
            </>
          );
        },
      },
      {
        key: 'id',
        title: 'Código',
        dataIndex: 'id',
      },
      {
        key: 'sucursal',
        title: 'Sucursal',
        dataIndex: 'sucursal',
      },
      {
        key: 'ciudad',
        title: 'Ciudad',
        dataIndex: 'ciudad',
      },
      {
        key: 'iva_fronterizo',
        title: 'Iva fronterizo',
        dataIndex: 'iva_fronterizo',
      },
      {
        key: 'codigo_postal',
        title: 'Código postal',
        dataIndex: 'codigo_postal',
      },
    ];
  };

  async componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(meta) {
    const { filters = {} } = this.props;

    this.props.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRowKeys: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  handleEdit = (item) => {};

  handleOnDelete = (item) => {
    this.props.remove(item, item.id);
  };

  renderError = () => {
    const { error } = this.props;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.resetError({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    const { result } = this.props;

    if (!!result) {
      this.props.highlight(result);
    }

    this.props.history.replace('/cuenta/sucursal');
  };

  render() {
    const { data, busy, error, onRowClick } = this.props;

    return (
      <>
        {!!error && this.renderError()}

        <Table
          loading={busy}
          columns={this.columns(this.handleEdit, this.handleOnDelete)}
          rowKey={'id'}
          data={data}
          pagination={this.getPaginationConfig()}
          onRowClick={onRowClick}
        ></Table>
      </>
    );
  }
}

const mapState = (state) => {
  return state.cuenta.sucursal.list;
};

const mapActions = (actions) => {
  return actions.cuenta.sucursal.list;
};

export default connect(useStore, mapState, mapActions)(SucursalList);
